import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart, AlertCircle, Truck, ClipboardList, PackageCheck, CreditCard, Box } from 'lucide-react';
import Card from '../../../components/ACS-Dashboard/ACS-Blocks/Card';
import ScrollableContainer from '../../../components/ACS-Dashboard/ACS-Blocks/ScrollableContainer';

const OrderList = () => {
  const navigate = useNavigate();

  // Card Data
  const orderCards = [
    { title: "Rejected Orders", percentage: "3%", comparisonText: "Nov vs Dec", mainValue: "8", icon: AlertCircle, percentageColor: "text-red-600", onButtonClick: () => navigate('/login'), buttonText: "See all" },
    { title: "Orders over Time", percentage: "5%", comparisonText: "Dec vs Jan", mainValue: "19", icon: ShoppingCart, onButtonClick: () => navigate('/orders'), buttonText: "Resolve" },
    { title: "Unapproved Invoices", percentage: "5%", comparisonText: "Dec vs Jan", mainValue: "30", showComparison: true, icon: ClipboardList, percentageColor: "text-red-600", onButtonClick: () => navigate('/invoices'), buttonText: "Review" },
    { title: "Delivered Orders", percentage: "10%", comparisonText: "Jan vs Feb", mainValue: "45", icon: Truck, percentageColor: "text-green-600", onButtonClick: () => navigate('/delivered'), buttonText: "View" },
    { title: "Pending Shipments", percentage: "7%", comparisonText: "Feb vs Mar", mainValue: "12", icon: Truck, onButtonClick: () => navigate('/shipments'), buttonText: "Track" },
    { title: "Returned Orders", percentage: "4%", comparisonText: "Mar vs Apr", mainValue: "5", icon: AlertCircle, percentageColor: "text-red-600", onButtonClick: () => navigate('/returns'), buttonText: "Details" },
    { title: "Pending Shipments", percentage: "7%", comparisonText: "Feb vs Mar", mainValue: "12", icon: Truck, onButtonClick: () => navigate('/shipments'), buttonText: "Track" },
    { title: "Returned Orders", percentage: "4%", comparisonText: "Mar vs Apr", mainValue: "5", icon: AlertCircle, percentageColor: "text-red-600", onButtonClick: () => navigate('/returns'), buttonText: "Details" },
    { title: "Pending Shipments", percentage: "7%", comparisonText: "Feb vs Mar", mainValue: "12", icon: Truck, onButtonClick: () => navigate('/shipments'), buttonText: "Track" },
    { title: "Returned Orders", percentage: "4%", comparisonText: "Mar vs Apr", mainValue: "5", icon: AlertCircle, percentageColor: "text-red-600", onButtonClick: () => navigate('/returns'), buttonText: "Details" },
  ];

  return (
    <div className="p-fluid-1 bg-color-custom-bg-purple">
    {/* Scrollable Orders List */}
    <ScrollableContainer direction="x"className="scrollbar-none">
    <div className="flex gap-[clamp(0.5rem,1cqw,1rem)]">
        {orderCards.map((card, index) => (
                      <div 
                      key={index} 
                      className="scroll-snap-align-start"
                      style={{ 
                        minWidth: 'clamp(12rem,30cqw,11rem)',  // 30% of container width
                        flex: '0 0 auto'  // Prevent flex growing
                      }}
                    >
                      <Card 
                        {...card}
                        className="p-fluid-1.5"
                        titleClassName="text-fluid-lg"
                        valueClassName="text-fluid-xl"
                        metaClassName="text-fluid-sm"
                      />
                    </div>
        ))}
      </div>
    </ScrollableContainer>
  </div>
  );
};

export default OrderList;
